module.exports = __webpack_public_path__ + "img/icon3.9b282f29.png";